import React from 'react';
import Header from './components/Header';
import Content from './components/Content';

export default function Settings() {
  return (
    <div>
      <Header />
      <Content />
    </div>
  );
}
